export interface IUser {
    title: string;
    firstName: string;
    lastName: string;
    email: string;
    telephone: string;
    mobile: string;
    fax: string;
    jobTitle: string;
    address1: string;
    address2: string;
    town: string;
    county: string;
    postcode: string;
    displayWelcomeFlag: boolean;
    forcePasswordChange: boolean;
    grants: string[];
    id: string;
    companyId: string;
    username: string;
    password: string;
    role: string;
    companyPrimaryContact: CompanyPrimaryContact;
}

export class User implements IUser {
    title: string;
    firstName: string;
    lastName: string;
    email: string;
    telephone: string;
    mobile: string;
    fax: string;
    jobTitle: string;
    address1: string;
    address2: string;
    town: string;
    county: string;
    postcode: string;
    displayWelcomeFlag: boolean;
    forcePasswordChange: boolean;
    grants: string[];
    id: string;
    companyId: string;
    username: string;
    password: string;
    role: string;
    companyPrimaryContact: CompanyPrimaryContact;
}

export interface IUserListModel {
    name: string;
    username: string;
    email: string;
    id: string;
    role: string;
}

export interface IGrant {
    name: string;
    value: string;
    avail: boolean;
}

export class IGrantItem {
    name: string;
    value: string;
}

export interface IChangePassword {
    id: string;
    oldPassword: string;
    newPassword: string;
}

export interface IForceChangePassword {
    userId: string;
    token: string;
    newPassword: string;
}

export interface CompanyPrimaryContact {
    title: string;
    firstname: string;
    lastname: string;
    contactNumber: string;
    emailAddress: string;
}

export interface IUserDrawingPoint {
    id: string;
    drawingPointNumber: string;
    accessEnabled: boolean;
}

export class UserDrawingPointModel {
    accesspoints: IUserDrawingPoint[];
    id: string;
}

export class WelcomeModel {
    EndPointURL: string;
    Token: string;
    userId: string;
}

export class UserModel {
    User: IUser;
    EndPointURL: string;
    Token: string;
    UserId: string;
    CompanyId: string;
}

export class UserDrawingPointsModel {
    EndPointURL: string;
    Token: string;
    UserId: string;
    UserDrawingPoints: IUserDrawingPoint[];
}

export class ChangePasswordModel {
    ChangePassword: IChangePassword;
    EndPointURL: string;
    Token: string;
    UserId: string;
}

export class IdentityUser {
    sub: string;
    email: string;
}



// WEBPACK FOOTER //
// ./src/app/users/user.ts